import { useMemo } from 'react'
import { StockType } from 'types/stock'
import differenceInMinutes from 'date-fns/differenceInMinutes'

// 渡されたstocksから最後に通知された時刻を判定して何分前か判定する
const useLastNotifiedMinutes = (stocks: StockType[]): number => {
  return useMemo(() => {
    const now = new Date()
    return stocks.reduce((prev, stock) => {
      if (!stock.last_notified_time) return prev
      const lastNotifiedAt = stock.last_notified_time.toDate()
      const diff = differenceInMinutes(now, lastNotifiedAt)
      if (diff < prev) {
        return diff
      } else {
        return prev
      }
    }, 1440) // 24h * 60min = 1440min
  }, [stocks])
}

export default useLastNotifiedMinutes
